import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DAY_MONTH_YEAR, DAY_MONTH_YEAR_DE, DAY_MONTH_YEAR_US } from '@rx-applications/shared/utils';
import { addMonths } from 'date-fns';

@Injectable({ providedIn: 'root' })
export class DateConversionService {
  toNgbDate(date: Date | string): NgbDate {
    const dateObject = new Date(date);
    return new NgbDate(dateObject.getFullYear(), dateObject.getMonth() + 1, dateObject.getDate());
  }

  ngbDateToString(date: NgbDate): string {
    const month: string = this.padZero(date.month);
    const day: string = this.padZero(date.day);
    return `${date.year}-${month}-${day}`;
  }

  toDate(date: NgbDate): Date {
    return new Date(date.year, date.month - 1, date.day);
  }

  getNextMonth(date: Date | string): NgbDate {
    const dateObject = new Date(date);
    return this.toNgbDate(addMonths(dateObject, 1));
  }

  constructor(@Inject(LOCALE_ID) protected localeId: string) {}

  getDateFormat(): string {
    switch (this.localeId) {
      case 'en-US':
        return DAY_MONTH_YEAR_US;
      case 'de':
        return DAY_MONTH_YEAR_DE;
      default:
        return DAY_MONTH_YEAR;
    }
  }

  getFirstDayOfWeek(): number {
    // 1 = Monday, 7 = Sunday
    return this.localeId === 'en-US' ? 7 : 1;
  }

  private padZero(num: number): string {
    return num < 10 ? '0' + num : '' + num;
  }
}
